module.exports = __webpack_public_path__ + "static/media/arrow-circle-right.6cbfc011.svg";